module.exports = __webpack_public_path__ + "static/media/01.94146c83.jpg";